import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        licence: '='
    },
    template: `
        <h1>{{ 'licence.Add licence' | translate }}</h1>
        <div class="well">
            <form class="form" ng-submit="vm.save()">
                <manage-settings-licences-form
                    form="vm.form"
                    show-precondition-toggle="false"
                />
                <button type="submit" class="hidden" >{{ 'licence.Add licence' | translate }}</button>
            </form>
            <ul class="actions01">
                <li class="primary">
                    <a ng-click="vm.save()" class="btn main">{{ 'licence.Add licence' | translate }}</a>
                </li>
                <li>
                    <a ui-sref="authorized.manage.settings.licences.list()" class="btn discrete"
                    >{{ 'general.Cancel' | translate }}</a>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($state, FormFactory) {
        this.$state = $state;
        this.form = FormFactory.createFromResource(this.licence);
    }

    save () {
        this.form.save()
            .then(model => {
                this.licence = model;
                this.$state.go('authorized.manage.settings.licences.detail', { id: model.id });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/settings/licences/add/index.js